import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Util } from '../../util/Util';
import { Constants } from '../../util/Constants';

/**
 * Generated class for the KintipsAvatarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'kintips-avatar',
  templateUrl: 'kintips-avatar.html'
})
export class KintipsAvatarComponent {

  @Input() src?: string = "";
  @Input() tipsterScore?: number = -1;
  @Input() tipsterId: number;
  @Input() size?: number = 50;
  @Input() tipPublished?: boolean = false;
  @Input() isPublishedTipRace?: boolean = false;
  @Input() highestScore?: number = -1;

  @Output("avatarClicked") avatarClicked = new EventEmitter();

  constructor() {

  }

  btnClicked() {
    this.avatarClicked.emit(this.tipsterId);
  }

  getProfileImgUrl() {
    if (this.src != null && this.src != "") {
      return this.src;
    } else {
      return Util.getImgUrl(Constants.Enum_ImageType.indexOf("Profile"), this.tipsterId);
    }
  }

  getProfileCap() {
    return Util.getProfileCap(this.tipsterScore, "big");
  }

  getProfileHighestScoreCap() {
    return Util.getProfileCap(this.highestScore, "big");
  }
}



// WEBPACK FOOTER //
// ./src/components/kintips-avatar/kintips-avatar.ts